// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".row+.row{margin-top:0}.save-list-create__title{display:flex;align-items:flex-end;height:100%;margin-top:20px;font-size:2em;font-weight:700}.v-list-item__content{text-align:left}", ""]);
// Exports
module.exports = exports;
